export default __webpack_public_path__ + "static/media/card2.38b5e193.png";